import videojs from 'video.js';
import { checkTouchScreen } from '../../js/helpers/checkTouchScreen';

const { dom } = videojs;

const ClickableComponent = videojs.getComponent('ClickableComponent');
const Component = videojs.getComponent('Component');

const defaultOptions = {
	value: null,
	breakpoints: ['1024', '812', '768', '375']
};

export default class ButtonSeek extends ClickableComponent {
	constructor(player, options) {
		super(player, videojs.mergeOptions(defaultOptions, options));

		this.timeFirstClick = 0;
		this.timeoutIdActiveSeek;
		this.inactivityTimeout;
		this.timeoutDoubleClick;

		this.isMobile = checkTouchScreen();

		this.addClass(`vjs-big-controls__seek_${this.options_.value > 0 ? 'forward' : 'backward'}`);

		dom.insertContent(
			this.$('.vjs-big-controls__seek-content'),
			`${this.options_.value <= 0 ? '' : '+'}${this.options_.value} сек`
		);

		player.on('ready', () => {
			this.show();

			if (this.isMobile) {
				this.player().off('dblclick');
				this.off(['dblclick', 'click', 'mousedown','mouseenter', 'mouseleave', 'mouseout', 'mouseover', 'mouseup']);
			};
		});
	}

	handleClick(evt) {
		evt.stopPropagation();
		evt.preventDefault();

		const isUserActive = this.player().userActive();
		const currentBreakpoint = this.player().getAttribute('data-css-breakpoint');
		const isEnableDoubleClick = this.options_.isEnableDoubleClick || this.options_.breakpoints.some((breakpoint) => breakpoint === currentBreakpoint);

		const seek = () => {
			const eventName = this.options_.value > 0 ? 'ButtonSeek/seekForward' : 'ButtonSeek/seekBackward';

			this.player().currentTime(this.player().currentTime() + this.options_.value);
			this.player().trigger(eventName);
		}

		if (isEnableDoubleClick) {
			const clickTime = Date.now();

			if (clickTime - this.timeFirstClick <= 400) {
				seek();
				this.timeFirstClick = 0;
				this.showHideActive();
				this.options_.onClick();

				if (!this.isMobile) return;
				clearTimeout(this.inactivityTimeout);
				this.doubleTouchEvent();

			} else {
				this.timeFirstClick = clickTime;

				if (!this.isMobile) return;
				if (isUserActive) return;
				if (this.player().hasClass('vjs-paused')) return;

				this.player().userActive(false);
				this.player().addClass('control-bar-hide');

				this.inactivityTimeout = setTimeout(() => {
					this.player().userActive(true);
					this.player().removeClass('control-bar-hide');
					this.timeFirstClick = 0;
				},400);
			}

		} else {
			seek();
			this.options_.onClick();
		}
	}

	doubleTouchEvent() {
		if (!this.player().hasClass('control-bar-hide')) return;

		clearTimeout(this.timeoutDoubleClick);
		this.player().userActive(false);

		this.timeoutDoubleClick = setTimeout(() => {
			this.player().userActive(false);
			this.player().removeClass('control-bar-hide');
		},1000);
	}

	showHideActive() {
		const buttonContent = this.$('.vjs-big-controls__seek-content');
		dom.addClass(buttonContent, 'vjs-big-controls__seek-content_active');
		clearTimeout(this.timeoutIdActiveSeek);
		this.timeoutIdActiveSeek = setTimeout(() => {
			dom.removeClass(buttonContent, 'vjs-big-controls__seek-content_active');
		}, 700);
	}

	createEl() {
		const el = dom.createEl('button', {
			className: 'vjs-big-controls__seek vjs-hidden'
		});
		el.append(dom.createEl('span', {
			className: 'vjs-big-controls__seek-content'
		}));
		return el;
	}
}

Component.registerComponent('ButtonSeek', ButtonSeek);
